'use client'

import {Button, SanityImage, SmallText} from '@local/ui/components'
import {LinkInput, SanityImageType} from '@local/types'
import {cx} from '@local/utils/cx'

export type PartnerCardProps = {
	image: SanityImageType
	title: string
	description: string
	partnerLink: LinkInput

}
export interface PartnersGridProps {
	surtitle: string
	description: string,
	entries: Array<PartnerCardProps>
}

export const PartnersGridContent = ({entries, surtitle}: PartnersGridProps) => {
	return (
		<div className='flex items-center justify-center lg-max:flex-col gutter-gap-1'>
			{entries.map((card, index) => (
				<PartnerCard key={index} {...card} />
			))}
		</div>
	)
}

const PartnerCard = ({image, title, description, partnerLink}: PartnerCardProps) => {
	return (

		<Button linkInput={partnerLink} className='text-center outline-none group/btn'>
			<figure className='aspect-square bg-white rounded-sm group flex items-center p-4 justify-center span-w-8-wide lg:span-w-2'>
				<SanityImage
					image={image}
					className='object-contain max-w-150' />
			</figure>
		</Button>

	)
}
